import {createFeatureSelector, createSelector} from "@ngrx/store";
import {SelectorUtil} from "@app-web-central/web/shared/utils";
import {foldersFeatureKey, FoldersState} from "./folders.reducer";

export const getFoldersState = createFeatureSelector<FoldersState>(foldersFeatureKey);

export const getFolders = createSelector(getFoldersState, (state) => state.data);

export const getFoldersLoading = createSelector(getFoldersState, SelectorUtil.isLoading);
